import React from "react";
import { Navigate, useParams } from "react-router-dom";

function Table() {
  const { tableName } = useParams();
  return <Navigate to={`/tables?table=${encodeURIComponent(tableName)}`} replace />;
}

export default Table;
